import { Route } from "@angular/router";

import {
  AuthGuard,
  EnrichmentGuard,
  offlineModeGuard,
  platformAppProfileGuard,
  ProfileConstants
} from "@frontends-v3/shared-core";

import { readerLandingGuard } from "./core/guards/reader-landing.guard";
import { AppNavBarComponent } from "./layout/navigation/navbar/navbar";

export const appRoutes: Route[] = [
  {
    path: "",
    // DEV-966 (CA 05): com o Modo Offline ligado só /action passa; o resto volta para lá.
    // `platformAppProfileGuard` logo depois do AuthGuard: perfil que não é da Plataforma (o
    // Administrador Lekto) vai para o próprio app antes de qualquer outro guard decidir algo.
    // DEV-1104: Aluno e Família (leitores) entram e o `readerLandingGuard` os mantém nas telas deles.
    canActivate: [
      AuthGuard,
      platformAppProfileGuard,
      readerLandingGuard,
      EnrichmentGuard,
      offlineModeGuard
    ],
    canActivateChild: [AuthGuard, platformAppProfileGuard, readerLandingGuard, offlineModeGuard],
    component: AppNavBarComponent,
    data: {
      profiles: ProfileConstants.PLATFORM_PROFILES
    },
    children: [
      {
        path: "",
        loadChildren: () => import("./features/home/home-routing").then((m) => m.homeRoutes)
      },
      {
        path: "class",
        loadChildren: () => import("./features/class/class-routing").then((m) => m.classRoutes)
      },
      {
        path: "action",
        loadChildren: () => import("./features/action/action-routing").then((m) => m.actionRoutes)
      },
      {
        path: "library",
        loadChildren: () =>
          import("./features/library/library-routing").then((m) => m.libraryRoutes)
      },
      {
        path: "review",
        loadChildren: () => import("./features/review/review-routing").then((m) => m.reviewRoutes)
      },
      {
        path: "my-account",
        loadChildren: () =>
          import("./features/my-account/my-account.routes").then((m) => m.myAccountRoutes)
      },
      {
        path: "manage-assignment",
        loadChildren: () =>
          import("./features/manage-assignment/manage-assignment-routing").then(
            (m) => m.manageAssignmentRoutes
          )
      }
    ]
  },
  {
    path: "enrichment",
    canActivate: [AuthGuard, platformAppProfileGuard],
    canActivateChild: [AuthGuard, platformAppProfileGuard],
    data: {
      profiles: ProfileConstants.ENRICHMENT_ELIGIBLE_PROFILES
    },
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./features/enrichment/enrichment-routing").then((m) => m.enrichmentRoutes)
      }
    ]
  },
  {
    path: "**",
    redirectTo: ""
  }
];
